import styled from 'styled-components';

import Input from '~/components/Input';

import { ThemeProp } from '../../../theme/Themes';
import { MainButton } from '../auth.styles';

export const CodeInstruction = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  margin-bottom: 1.5rem;
`;

export const CodeInstructionEmail = styled(CodeInstruction)`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const StyledTextField = styled(Input)`
  margin-top: 16px;
`;

export const SubmitButton = styled(MainButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    marginTop: '$8',
  },
}))``;
